// PUB-1424: dwie minuty — tyle, ile front czeka na domknięcie miesięcy, zanim powie
// „nie udało się, spróbuj ponownie”. Kolejna próba ma krótszą listę, bo miesiące
// domknięte przed przerwaniem zostają zamknięte.
const AUTO_CLOSE_TIMEOUT_MS = 120000;

export default {
  indexClosedMonth(url) {
    return axios.get(import.meta.env.VITE_SITE_URL + '/bookkeepings/evidences/closed-months' + url,
      {
        params: {},
      },
    );
  },
  // PUB-1424: które miesiące stoją na drodze do zamknięcia miesiąca N. Sam odczyt.
  closureWindow({ year, month } = {}) {
    return axios.post(
      import.meta.env.VITE_SITE_URL + '/bookkeepings/evidences/closed-months/closure-window',
      { year, month },
    );
  },

  // PUB-1424: domyka zatwierdzoną przez użytkownika listę miesięcy. Operacja jest
  // synchroniczna i długa — każdy miesiąc to osobne zamknięcie — a backend nie ma własnego
  // limitu czasu, więc ustawiamy go tutaj i mówimy wprost, żeby spróbować ponownie.
  autoCloseMonths({ year, months } = {}, timeout = AUTO_CLOSE_TIMEOUT_MS) {
    return axios.post(
      import.meta.env.VITE_SITE_URL + '/bookkeepings/evidences/closed-months/auto-close',
      { year, months },
      { timeout },
    );
  },

  show(id, config = {}) {
    return axios.get(import.meta.env.VITE_SITE_URL + `/bookkeepings/evidences/closed-months/${ id }`, config);
  },

  updateClosedMonth(closedMonth) {
    return axios.put(import.meta.env.VITE_SITE_URL + '/bookkeepings/evidences/closed-months/' + closedMonth.id,
      {
        evidenceclosedmonth: closedMonth,
      },
    );
  },
  taxStatements({
                  year,
                  month,
                  evidencetype,
                  pitsettlementsperiodtype,
                } = {}) {
    return axios.get(
      import.meta.env.VITE_SITE_URL + '/bookkeepings/evidences/closed-months/tax-statements',
      {
        params: {
          year,
          month,
          evidencetype,
          pitsettlementsperiodtype,
        },
      },
    );
  },
  sendMailToClient({
                     year,
                     month,
                     evidencetype,
                     pitsettlementsperiodtype,
                     evidenceclosedmonthid,
                   } = {}) {
    return axios.get(
      import.meta.env.VITE_SITE_URL + '/bookkeepings/evidences/closed-months/send-mail-to-client',
      {
        params: {
          year,
          month,
          evidencetype,
          pitsettlementsperiodtype,
          evidenceclosedmonthid,
        },
      },
    );
  },
  getCloseMonthSummaryData({
                             date_period,
                             vat_payer,
                           } = {}) {
    return axios.get(
      import.meta.env.VITE_SITE_URL + '/bookkeepings/evidences/closed-months/get-close-month-summary-data',
      {
        params: {
          date_period,
          vat_payer,
        },
      },
    );
  },
};
